// @flow

import { createSelector } from 'reselect'
import { isEmpty } from 'ramda'
import { isNotNilOrEmpty } from 'ramda-adjunct'

import {
  getSupportEmail as getBrandEmail,
  getSupportWww as getBrandWww,
  getSupportPhone as getBrandPhone,
  getSupportPhones as getBrandPhones,
  getSupportWA as getBrandWA,
  getBrandTitle,
  getBrandAddress,
} from '@alphaott/app-main/selectors'

import type { Address } from '@alphaott/common-types'

import {
  getServiceProviderSupportEmail,
  getServiceProviderWww,
  getServiceProviderPhone,
  getServiceProviderPhones,
  getServiceProviderWA,
  getServiceProviderAddress,
  getServiceProviderTitle,
} from './serviceProvider'

export const getSupportTitle = createSelector(
  [getServiceProviderTitle, getBrandTitle],
  (serviceProviderName: string, brandName: string): string => serviceProviderName || brandName,
)

export const getSupportEmail = createSelector(
  [getServiceProviderSupportEmail, getBrandEmail],
  (serviceProviderEmail: string, brandEmail: string): string => serviceProviderEmail || brandEmail,
)

export const getSupportWww = createSelector(
  [getServiceProviderWww, getBrandWww],
  (serviceProviderWeb: string, brandWeb: string): string => serviceProviderWeb || brandWeb,
)

export const getSupportPhone = createSelector(
  [getServiceProviderPhone, getBrandPhone],
  (serviceProviderPhone: string, brandPhone): string => serviceProviderPhone || brandPhone,
)

export const getSupportPhones = createSelector(
  [getServiceProviderPhones, getBrandPhones],
  (serviceProviderPhones: string[] = [], brandPhones: string[] = []): string[] => {
    if (isNotNilOrEmpty(serviceProviderPhones)) {
      return serviceProviderPhones
    }

    return brandPhones
  },
)

export const getSupportWA = createSelector(
  [getServiceProviderWA, getBrandWA],
  (serviceProviderWA: string[] = [], brandWA: string[] = []): string[] => {
    if (isNotNilOrEmpty(serviceProviderWA)) {
      return serviceProviderWA
    }

    return brandWA
  },
)

// prettier-ignore
export const getSupportAddress = createSelector(
  [getServiceProviderAddress, getBrandAddress],
  (serviceProviderAddress, brandAddress): Address =>
    (isEmpty(serviceProviderAddress) ? brandAddress : serviceProviderAddress),
)
